import React, { Component } from 'react';

import EditContactForm from './EditContactForm';
import Otp from '../../Auth/Otp';
import UserService from '../../../Service/UserService';
import { hot } from 'react-hot-loader';

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_openScreen: '',
			_updatedContactDetail: '',
			_isLoading: false
		};
	}

	startLoader = () => {
		this.setState({
			_isLoading: true
		});
	};

	stopLoader = () => {
		this.setState({
			_isLoading: false
		});
	};

	updateContactdetails = async userContactDetail => {
		try {
			this.startLoader();
			const response = await UserService.updateContactInfo(userContactDetail);
			this.setState({
				_updatedContactDetail: userContactDetail
			});
			this.stopLoader();
			return response;
		} catch (error) {
			console.log(error);
			this.stopLoader();
		}
	};

	verifyUserDetail = async otp => {
		try {
			const requestBody = {};
			if (this.props.contactDetailMode === 'Email') {
				requestBody.email = this.state._updatedContactDetail.email;
			} else {
				requestBody.phone = this.state._updatedContactDetail.phone;
			}
			requestBody.otp = otp;
			const response = await UserService.verifyUserContactDetail(requestBody);
			const updatedUser = await UserService.updateCurrentUser();
			await this.props.setCurrentUser(updatedUser);
			if (response.status) {
				this.props.onBack();
			} else {
				return response;
			}
		} catch (error) {
			console.log(error);
		}
	};

	resendOtp = async () => {
		const requestBody = {};
		if (this.props.contactDetailMode === 'Email') {
			requestBody.email = this.state._updatedContactDetail.email;
		} else {
			requestBody.phone = this.state._updatedContactDetail.phone;
		}
		await this.updateContactdetails(requestBody);
	};

	openOtpScreen = () => {
		this.setState({
			_openScreen: 'OTP'
		});
	};

	render() {
		if (this.state._openScreen === 'OTP') {
			return (
				<Otp
					fromEditContact
					mode={this.props.contactDetailMode === 'Phone' ? 'email' : 'mobile'}
					resendOtp={this.resendOtp}
					verifyOtp={this.verifyUserDetail}
				/>
			);
		} else {
			return (
				<EditContactForm
					contactDetailMode={this.props.contactDetailMode}
					currentUser={this.props.currentUser}
					isLoading={this.state._isLoading}
					mode={this.props.contactDetailMode}
					onBack={this.props.onBack}
					onSubmit={this.updateContactdetails}
					openOtpScreen={this.openOtpScreen}
				/>
			);
		}
	}
}

export default hot(module)(index);
